<div class="address-edition__title" *ngIf="!!title">{{ title }}</div>
<form [formGroup]="form" class="address-edition__form">
    <div class="row" [class.d-none]="hidePostalCode">
        <div class="col-12">
            <sc-select formControlName="postalCode" label="Código postal" placeholder="Ej: 2000"
                enableSearch="true" objectValue="name" [itemsAsync$]="postalCodeOptions$"
                [maxlength]="POSTAL_CODE_MAX_LENGTH" [loading]="loadingPostalCode" #postalCodeSelector
                (keyup)="getCitiesOnKeyUp($event)"></sc-select>
        </div>
    </div>
    <div class="row">
        <div class="col-md-7">
            <sc-input formControlName="streetName" label="Calle" placeholder="Montevideo"></sc-input>
        </div>
        <div class="col-md-5">
            <sc-input formControlName="number" label="Número" placeholder="1123"
            [errorMessages]="numberErrorMessages"></sc-input>
        </div>
    </div>
    <div class="row">
        <div class="col-md-7">
            <sc-input formControlName="floor" type="number" label="Piso (Opcional)" placeholder="Ej: 3"></sc-input>
        </div>
        <div class="col-md-5">
            <sc-input formControlName="department" label="Dpto (Opcional)" placeholder="Ej: D"></sc-input>
        </div>
    </div>
</form>
<div class="row address-edition__info-box" *ngIf="postalCodeMessage && form.controls.postalCode.dirty">
    <sc-info-box>{{ postalCodeMessage }}</sc-info-box>
</div>